var companyExists_gql_default = `
  query doesCompanyExist($orgNo: String!) {
    WmCompanyExists(vat_tax_id: $orgNo) {
      exists
    }
  }
`;
export {
  companyExists_gql_default as default
};
